import axiosInstance from "../helpers/axiosInstance"

export const fetchNaturaOpsAllowedWarehouses = async () => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-operations/warehouses`)
  return res.data
}

// Posts to platform (not natura-sftp-monitor), so axiosInstance's JWT applies.
export const uploadNotfis = async (file) => {
  const form = new FormData()
  form.append("file", file)
  const res = await axiosInstance.post(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-operations/notfis-uploads`,
    form
  )
  return res.data
}
